export enum Env {
  Prod = 'prod',
  Preprod = 'pprod',
  Int = 'int',
  Test = 'test'
}

export type UrlEnv =
  | Env.Prod
  | 'prodCached'
  | Env.Preprod
  | Env.Int
  | Env.Test
  | 'local'
  | 'ffgDev'
  | 'ffgProd'
  | 'dev';
type StyleKeys = 'legacyWorkbench';
type AnUrl = string;

export type SingleEnvConfig = AnUrl;
export type MultipleEnvConfig = Record<Env.Prod, SingleEnvConfig> & Partial<Record<UrlEnv, SingleEnvConfig>>; // prod is necessary, other envs optional

/**
 * compareTeaser: former sim search
 * compare: allows to compare user's configurations with an in stock vehicle
 * upsellingRecommendation: recommendation component configured for sales expert mode
 * aemForms: AEM forms
 * wishlist: component to store the configured vehicle
 * fcis: Financial Calculator
 * price display: Price Display component from Price Listing Service (PLS)
 */
export type ScriptDomain =
  | 'compareTeaser'
  | 'compare'
  | 'upsellingRecommendation'
  | 'aemForms'
  | 'wishlist'
  | 'energyConsumptionLabeling'
  | 'fcis'
  | 'priceDisplay'
  | 'legacyWorkbench';

export interface Urls {
  apis: Record<string, Partial<Record<UrlEnv, AnUrl>>>;
  scripts: Record<ScriptDomain, SingleEnvConfig | MultipleEnvConfig>;
  misc: Record<string, AnUrl>;
  styles: Record<StyleKeys, AnUrl>;
}
